import { ReactComponent as LoaderSvg } from 'images/icons/loader.svg'

import style from './LoaderSpinner.module.css'

const LoaderSpinner = () => <LoaderSvg className={style.loader} />

export default LoaderSpinner
